// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"46b9d752","408":"d5ca3c3d"}[chunkId] + ".chunk.js";
};